// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_QB\\+7z{display:flex}", ""]);
// Exports
exports.locals = {
	"container": "container_QB+7z"
};
module.exports = exports;
